module.exports = __webpack_public_path__ + "1_0_59/img/arrow_back.c86d870f.svg";